import React from "react";
import * as Icon from "react-feather";

import WComponent from "../common/WComponent";
import ToolsTextEntryModal from "../clients/Tools/kit/ToolsTextEntryModal";
import BuildConversation from "./BuildConversation";

import "./build-page.css";
import "./playbook-build-page.css";

class PlaybookBuildConversationPanel extends WComponent {
	constructor(props) {
		super(props);
		this.state = {
			draftText: "",
			isPasteOpen: false,
			pastedPrompt: "",
		};
	}

	onDraftTextChange = ({ text }) => {
		this.update({ draftText: text });
	};

	onSend = async () => {
		const text = this.state.draftText.trim();
		if (!text) return;
		await this.update({ draftText: "" });
		const isSent = await this.props.onSendText({ text });
		if (!isSent) await this.update({ draftText: text });
	};

	onOpenPaste = () => {
		this.update({ isPasteOpen: true });
	};

	onClosePaste = () => {
		this.update({ isPasteOpen: false });
	};

	onPastedPromptChange = ({ text }) => {
		this.update({ pastedPrompt: text });
	};

	onImportPrompt = async () => {
		const prompt = this.state.pastedPrompt.trim();
		await this.update({ isPasteOpen: false });
		const isImported = await this.props.onImportPrompt({ prompt });
		if (isImported) await this.update({ pastedPrompt: "" });
	};

	renderDraftSkill = ({ draftSkill, isLatest }) => {
		const { session, isSending, onAddDraftSkill, onDeclineDraftSkill } = this.props;
		const isOpen = session.status === "open";
		const { addedSkill } = draftSkill;
		return (
			<div className="playbook-build__draft-skill">
				<div className="playbook-build__draft-skill-head">
					<Icon.BookOpen size={14} />
					Drafted skill: {draftSkill.name}
					{addedSkill && !addedSkill.isNoLongerInLibrary && <span className="tk-badge tk-badge--success">Added as v{addedSkill.versionNumber}</span>}
					{addedSkill && addedSkill.isNoLongerInLibrary && <span className="tk-badge">Added, since removed from the library</span>}
				</div>
				<div className="playbook-build__draft-skill-description">{draftSkill.description}</div>
				<pre className="build-card__text playbook-build__draft-skill-body">{draftSkill.body}</pre>
				{isOpen && isLatest && !addedSkill && (
					<div className="playbook-build__draft-skill-actions">
						<button type="button" className="tk-button tk-button--primary tk-button--compact" onClick={() => onAddDraftSkill({ draftSkill })} disabled={isSending}>
							<Icon.Plus size={13} />
							Add to the firm's skills
						</button>
						<button type="button" className="tk-text-action tk-text-action--muted" onClick={() => onDeclineDraftSkill({ draftSkill })} disabled={isSending}>
							Not now
						</button>
					</div>
				)}
			</div>
		);
	};

	renderAttachment = ({ message, isLatest }) => {
		if (!message.draftSkill) return null;
		return this.renderDraftSkill({ draftSkill: message.draftSkill, isLatest });
	};

	render() {
		const { session, isSending, progress, composerRef, hasWelcome } = this.props;
		const { draftText, isPasteOpen, pastedPrompt } = this.state;
		const hasPersonMessage = session.messages.some(message => message.from === "person");
		const isNewPlaybookUnstarted = !session.playbookId && !hasPersonMessage;
		const placeholder = isNewPlaybookUnstarted ? "Describe the job you'd like to automate…" : undefined;
		return (
			<React.Fragment>
				<BuildConversation
					hasWelcome={hasWelcome}
					placeholder={placeholder}
					composerRef={composerRef}
					messages={session.messages}
					isSending={isSending}
					progress={progress}
					isOpen={session.status === "open"}
					draftText={draftText}
					onDraftTextChange={this.onDraftTextChange}
					onSend={this.onSend}
					renderAttachment={this.renderAttachment}
					secondaryAction={
						<button type="button" className="tk-text-action tk-text-action--muted" onClick={this.onOpenPaste} disabled={isSending}>
							<Icon.Clipboard size={13} />
							Paste a prompt you already have
						</button>
					}
				/>
				<ToolsTextEntryModal
					isOpen={isPasteOpen}
					title="Paste a prompt you already have"
					width={680}
					intro="From a Gemini Gem, a custom GPT, or your own notes. The guide reads it, fills in the brief and asks only what it leaves open. It stays with this conversation and is not shown to anyone else."
					text={pastedPrompt}
					rows={14}
					confirmLabel="Use this prompt"
					onTextChange={this.onPastedPromptChange}
					onCancel={this.onClosePaste}
					onConfirm={this.onImportPrompt}
				/>
			</React.Fragment>
		);
	}
}

export default PlaybookBuildConversationPanel;
